/* src/app/dialogs/attachment-controller/attachment-controller.component.scss */
ul.directories li {
  list-style: none;
}
ul.directories li:before {
  margin: 0 5px 0 -15px;
}
a:link,
a:hover,
a:active,
a:visited {
  color: black;
}
.mat-mdc-list-item-icon img {
  max-height: 40px;
  transition: 0.5s;
  position: absolute;
  top: 22px;
  left: 13px;
}
.mat-mdc-list-item-icon:hover img {
  max-height: 125px;
  z-index: 100;
  top: -20px;
  position: absolute;
  left: -35px;
  transition: 0.5s;
}
/*!
 * The tree view (right side)
 */
/*# sourceMappingURL=attachment-controller.component-AIQT6IVN.css.map */
